import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
	name: 'reactions',
	initialState:{
		show:false,
		heading:'',
		src:''
	},
	reducers: {
		update : (state,action)=>{
			Object.entries(action.payload).forEach(([k,v])=>{
				state[k] = v
			})
		}
	},
})

export const {update} = slice.actions

export default slice.reducer